import { gql } from 'apollo-angular';

export const MCP_TOKENS_QUERY = gql`
    query McpTokens {
        mcpTokens {
            id
            createdAt
            expiration
            isValid
            used
            lastUsed
            metadata
        }
    }
`;

export const CREATE_MCP_TOKEN_MUTATION = gql`
    mutation CreateMcpToken(
        $name: String!
        $provider: String!
        $scope: String!
        $expiration: Int
    ) {
        createMcpToken(
            name: $name
            provider: $provider
            scope: $scope
            expiration: $expiration
        ) {
            id
            token
            createdAt
            expiration
            metadata
        }
    }
`;

export const REVOKE_MCP_TOKEN_MUTATION = gql`
    mutation RevokeMcpToken($tokenId: String!) {
        revokeMcpToken(tokenId: $tokenId)
    }
`;
